import { Routes } from '@angular/router'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { SystemSettingsComponent } from './system-settings.component'

export const searchRoutes: Routes = [
  {
    path: 'admin/settings/system_settings',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: SystemSettingsComponent,
        data: {
          permissions: {
            only: 'SYSTEM_SETTINGS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
